import { defineChain } from 'viem';

export const unit0 = defineChain({
  id: 88811,
  name: 'Unit Zero',
  nativeCurrency: { name: 'UNIT0', symbol: 'UNIT0', decimals: 18 },
  rpcUrls: {
    default: {
      http: ['https://rpc.unit0.dev'],
    },
  },
  blockExplorers: {
    default: {
      name: 'Unit Zero Mainnet explorer',
      url: 'https://explorer.unit0.dev/',
    },
  },
  contracts: {
    multicall3: {
      address: '0xca11bde05977b3631167028862be2a173976ca11',
      blockCreated: 2577142,
    },
  },
});
